import React, { ReactElement } from 'react';
import { cn } from '@/lib/utils';

type TextProps = {
  className?: string;
};

type Props = {
  primaryText: string;
  primaryTextProps?: TextProps;
  secondaryText: string;
  secondaryTextProps?: TextProps;
  icon: ReactElement;
  secondaryAction?: ReactElement;
  children?: ReactElement;
};

function ListItem({
  primaryText,
  primaryTextProps = {},
  secondaryText,
  secondaryTextProps = {},
  icon,
  secondaryAction,
  children,
}: Props) {
  return (
    <div className="flex items-center gap-3 w-full">
      {icon && (
        <div className="size-12 flex items-center justify-center rounded-[10px] border border-border bg-white/5 text-muted-foreground shrink-0 [&_img]:max-w-full">
          {icon}
        </div>
      )}
      <div className="flex flex-col min-w-0">
        <span
          className={cn(
            'text-xs uppercase tracking-widest text-muted-foreground',
            primaryTextProps.className
          )}
        >
          {primaryText}
        </span>
        <span
          className={cn(
            'text-sm tracking-tight text-foreground',
            secondaryTextProps.className
          )}
        >
          {secondaryText}
        </span>
      </div>
      {children}
      {secondaryAction && <div className="ml-auto">{secondaryAction}</div>}
    </div>
  );
}

export default ListItem;
